// Single source of truth for the landing-page FAQ. The visible FAQ
// section (LandingPage) and the FAQPage JSON-LD the worker injects on
// "/" both render from this array — Google's rich-results rules require
// the structured answers to match the on-page text verbatim, and one
// module makes that mechanical. Plain text only (no markup) so the same
// strings serialize cleanly into JSON-LD.

export interface LandingFaqItem {
  question: string;
  answer: string;
}

export const LANDING_FAQ: readonly LandingFaqItem[] = [
  {
    question: "Is Traffic Snapshot really free?",
    answer:
      "Yes. Connect a GA4 property and the report, UTM Health score, branded PDF, CSV exports and weekly digest are all free, and there is no credit card to enter. It's built by Sked Social, the social media management platform; if you ever want the publishing side, that's the paid product.",
  },
  {
    question: "What access does it take, and what do you store?",
    answer:
      "Read-only Google Analytics access (analytics.readonly) plus your email and profile for sign-in. We never store row-level GA4 data. Reports are fetched live, and a derived summary is cached briefly for performance. Disconnect from Settings any time and your data is deleted.",
  },
  {
    question: "Can agencies run it per client?",
    answer:
      "Yes. The property picker lists every GA4 property your Google account can access, so you can switch between client properties, pull the same social-first report for each, and send each client a branded share link or PDF.",
  },
  {
    question: "Does it change anything in my GA4 property?",
    answer:
      "No. The connection is read-only and can't edit tags, events, audiences or settings. It only reads reporting data you already have.",
  },
  {
    question: "How fresh are the numbers?",
    answer:
      "Reports query the GA4 Data API live, with a short cache (about an hour) to keep repeat loads fast. The UTM Health score recalculates with every fresh report.",
  },
];
